import { apiFetch } from '../config/api'
import type { ProjectDetails } from '../types'
import { normalizeTiltGapBreakDelta } from './passAnalyticsGraphAxis'

/**
 * Persist Pass Analytics tilt gap break (° ) for a project (shared team setting).
 */
export async function patchProjectGraphTiltLineBreak(
  projectId: string,
  graphTiltLineBreakDelta: number
): Promise<ProjectDetails> {
  const updated = await apiFetch<ProjectDetails>(
    `/api/projects/${encodeURIComponent(projectId)}/graph-tilt-line-break`,
    {
      method: 'PATCH',
      body: JSON.stringify({ graphTiltLineBreakDelta })
    }
  )
  return {
    ...updated,
    graphTiltLineBreakDelta: normalizeTiltGapBreakDelta(updated.graphTiltLineBreakDelta)
  }
}
